'use strict';

import $ from 'jquery';
import dt from 'datatables.net-dt';
// import dtFixedCols from 'datatables.net-fixedcolumns-dt';
import dtFixedHead from 'datatables.net-fixedheader-dt';
import dtResponsive from 'datatables.net-responsive-dt';

dt()
dtFixedHead()
dtResponsive()

class TabularData {
  constructor(options, selector) {

    // DataTables binds functions to itself, so we need a reference to the class instance
    const tabularData = this;

    this.disablePages = ['.page--main-listing', '.page--archive'];

    // Predefined order for status values

    // See docs @ https://datatables.net/reference/option/
    const defaults = {
      disableOrderingPages: ['.page--repair-cost-statement'],
      autoWidth: true,
      columnDefs: [{
        targets: 'invisible',
        visible: false
      }],
      fixedHead: true,
      responsive: false,
      searching: true,
      scrollX: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: 0, // save state for indefinite duration (-1 for sessionStorage, >=0 for localStorage)
      initComplete: function() {
        // NOTE: Here, `this` is bound to the DataTables instance
        tabularData.postInit(this)
      },
      language: window.tabularDataTranslations || {},
      search: {
        regex: false
      },
      orderClasses: false,
      defer: true
    };

    this.settings = Object.assign({}, defaults, options);
    this.selector = selector || '.datatable';
  }

  init() {
    // exit early, if module disabled or no datatable on page
    if(
      document.querySelector(this.disablePages.join(',')) ||
      !document.querySelector(this.selector)
    ) return;

    // Use BEM-like classnames
    $.fn.dataTableExt.oStdClasses.sSortAsc = 'sorting--asc';
    $.fn.dataTableExt.oStdClasses.sSortDesc = 'sorting--desc';
    $.fn.dataTableExt.oStdClasses.sSortColumn = 'sorting--';
    $.fn.dataTableExt.oStdClasses.sSortable = 'sorting';

    this.$dataTable = $(this.selector);

    let orderSettings = {
      ordering: true
    }
    if(document.body.matches(this.settings.disableOrderingPages)) {
      orderSettings = {
        order: [],
        ordering: false
      }
    }

    let pagingSettings = {
      paging: false,
      scrollY: false,
      info: false
    }
    // Choose paging -related settings by data-paging attribute
    if(this.$dataTable.data('paging') === true) {
      pagingSettings = {
        paging: true,
        scrollY: '70vh', // Creates a scroll container
        lengthMenu: [[25, 100, -1], ['25', '100', 'Kaikki']],
        pageLength: 25, // Default lengthMenu selection
        info: true, // Show result counts ("kohteet 1 - 25 / 65")
      };
    }

    this.settings = {
      ...this.settings,
      ...orderSettings,
      ...pagingSettings
    };

    // Store a reference to the dataTable object
    this.dataTable = this.$dataTable.DataTable(this.settings);

    //table is ready for render
    $(this.selector).show();
    $('.spinner').hide();
  }

  /**
   * DataTables post initialization actions
   * @param {Object} dataTable - the DataTable instance
   */
  postInit(dataTable) {
    if(this.$dataTable.data('paging') === true) {
      const container = dataTable.api().table().container();
      container.classList.add('paging');
    }

    // Queue a widths recalculation
    // Doesn't always work without the timeout
    setTimeout(() => {
      dataTable.api().columns.adjust();
    }, 1);
  }

  /**
   * Formats a cell's data with a custom function.
   * The function should take one argument, containing the cell's initial data
   * It should return an object, containing at least a `value` key. If the object
   * contains a `html` key, that value is displayed in the table instead.
   *
   * Internally, the returned function is called when DT is initialized, but
   * also when it needs to read data, e.g. when sorting, changing pages etc.
   *
   * @param {Function} formatter - The formatter function
   * @returns {Function} - A data function suitable for DataTables
   */
  formatData(formatter) {
    return (row, type, value, meta) => {
      if(type === 'set') {
        // Format and save data when cell is being initialized
        if(!row.formattedDatas) row.formattedDatas = [];
        const formattedData = formatter(value);
        row.formattedDatas.push(formattedData);
        return;
      }
      const cellData = row.formattedDatas[meta.col];
      if(type === 'display') {
        // Read formatted data for displaying on the page
        return cellData.html || cellData.value;
      }
      else if(type === 'sort') {
        // Read formatted data for sorting rows
        return cellData.sort || cellData.value;
      }
      // Read data for filtering etc.
      return cellData.value;
    }
  }
}

export default TabularData;
export { TabularData };
